<template>
  <div class="dispatch-form-base">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input :value="value.xmbh" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="任务编号">
          <el-input :value="value.rwbh" :disabled="readonly" @input="patch('rwbh', $event)" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="项目名称">
      <el-input :value="value.xmmc" disabled />
    </el-form-item>
    <el-form-item label="委托单位">
      <el-input :value="value.wtdw" disabled />
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="要求完成时间">
          <el-date-picker
            :value="value.yqwcsj"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:100%"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="派遣地点">
          <el-input :value="value.pqdd" disabled />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="采样人员">
          <el-input :value="value.cyry" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="现场实施方案">
          <el-input :value="xcssfaLabel" disabled />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item v-if="value.bz" label="期次备注">
      <el-input type="textarea" :value="value.bz" :autosize="{ minRows: 1 }" disabled />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'DispatchFormBase',
  props: {
    value: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: true }
  },
  computed: {
    xcssfaLabel() {
      const v = this.value || {}
      const n = v.xcssfa_num
      return v.xcssfa ? `${v.xcssfa}${n ? ' · ' + n + '个点位' : ''}` : '—'
    }
  },
  methods: {
    patch(key, val) {
      this.$emit('input', { ...this.value, [key]: val })
    }
  }
}
</script>
